/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .factory('ZcsImage', zcsImage);

zcsImage.$inject = ['Api'];
function zcsImage(Api) {

  class ZcsImage {
    static create(params, data) {
      return Api.post(`/api/projects/${params.projectId}/images.json`, {}, {
        method: 'POST',
        headers: {
          'Content-Type': undefined
        },
        data,
        transformRequest(outgoingData) {
          const fd = new FormData();
          // val key order!
          angular.forEach(outgoingData, (val, key) => fd.append(key, val));
          return fd;
        }
      }
      );
    }

    static get(params) {
      return Api.get(`/api/projects/${params.projectId}/images/${params.imageId}`)
        .then(res => res.data.image);
    }
  }
  return ZcsImage;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/zcs_image.service.js